<template>
    <div class="comments_wrap" >
            <div class="top">                
                <div>
                    댓글<span> {{getComments.length}}</span>
                </div>    
                <div class="select_sort select">
                    <select name="" id="" @change="selectSort()" v-model="commentSort">
                        <option value="desc">최신순</option>
                        <option value="asc" >과거순</option>                       
                    </select>
                </div>
               
            </div>
            <div class="comments" >
                
                <template v-for="comment in getComments" :key="comment.id">
                    <div class="item"  v-if="comment.comment_id ===null">
                        <div class="register_info">
                            <div class="user">
                                <!-- <user-nick :user="comment.user"/> -->
                             <user-name-tag :user="comment.user" 
                                :displaymytalk="false" :displayProfileImage="false" :lineheight="true"/>
                            </div>
                            <div class="recomment" @click="showRecomment($event,comment.id)">답글</div>
                            <div class="regdate">
                                <date-time :time="comment.created_at" type="1"/>
                            </div>
                            <div v-if="currentUser.id === comment.user_id || currentUser.role === 'admin'">
                                <a href="javascript:void(0)" @click="deleteComment(comment.id)" class="btn_delete">[삭제요청]</a>
                            </div>

                        </div>
                        <div class="comment_cont">
                            <pre>{{ comment.body }}</pre>
                        </div>   
                        <div :class="`ccomment_form_${comment.id}`" class="ccomment_form">
                            <ccomment 
                                :postid="comment.post_id" 
                                :ccommentId="comment.id"                                  
                                @save-comment="saveComment" 
                                />
                        </div>                    
                        
                    </div>
                    <!--대댓글-->
                    <template v-if="comment.ccomment.length > 0">
                           
                        <div class="item ccomment"  v-for="ccomment in comment.ccomment" :key="ccomment.id">
                            <div class="register_info">
                                <div class="user">
                                    <!-- └ <user-nick :user="comment.user"/> -->
                                     └<user-name-tag :user="ccomment.user" 
                                :displaymytalk="false" :displayProfileImage="false" :lineheight="true"/>
                                    </div>
                                <div class="recomment" @click="showRecomment($event,ccomment.id)">답글</div>    
                                <div class="regdate">
                                <date-time :time="ccomment.created_at" type="1"/>
                                </div>
                                <div v-if="currentUser.id === ccomment.user_id || currentUser.role === 'admin'">
                                    <a href="javascript:void(0)" @click="deleteComment(ccomment.id)" class="btn_delete">[삭제요청]</a>
                                </div>

                            </div>
                            <div class="comment_cont">                               
                                <pre > <span v-if="ccomment.cuser" class="touser">To. {{ccomment.cuser.nic}}</span> {{ ccomment.body }}</pre>
                            </div>
                            <div :class="`ccomment_form_${ccomment.id}`" class="ccomment_form">
                                <ccomment 
                                    :postid="comment.post_id" 
                                    :ccommentId="comment.id" 
                                    :ccommentUserId="ccomment.user_id"                                     
                                    @save-comment="saveComment"/>
                             </div>   
                        </div>    
                    </template>
                    
                    <!-- <div class="ccomment_write" v-if="comment.comment_id ===null">
                        <span @click="show_ccommentform($event)">답글작성</span>
                        <div class="ccomment_form">
                            <ccomment :postid="comment.post_id" :ccommentId="comment.id"  @save-comment="saveComment"/>
                        </div>
                    </div>     -->
                    <div class="ccomment_write" v-if="comment.comment_id ===null">
                    </div>    
                </template>

            </div>
        </div>
</template>
<script>
//import UserNick from "@/components/site/parts/UserNick";
import DateTime from "@/components/site/parts/DisplayTime";
import Ccomment from "@/components/posts/PostCommentForm";
import { commentSubmit } from "@/components/mixins/commentSubmit.js"
export default {    
    data(){
        return{
            CommentsData:'',
            commentSort:'',

        }
    },
    components:{
        DateTime,
       // UserNick,
        Ccomment,
       
    },
    mixins:[commentSubmit],
    computed:{
        currentUser(){
            return this.$store.getters.currentUser;
        },
        getComments(){    
            return this.$store.state.posts.viewpost.comments;           
        },       
    },
    mounted() {
        if(this.$store.state.menu.activeMenu ==="Gamegrade")
        {
            this.commentSort ="asc";
            this.$store.state.posts.viewpost.comments.reverse();
            this.$store.state.posts.commentSort = "asc";
        }else{
            this.commentSort ="desc";
            this.$store.state.posts.viewpost.comments;
            this.$store.state.posts.commentSort = "desc";
        }   
        
    },
    methods:{      
        selectSort()
        {
            this.getComments.reverse();   
            this.$store.state.posts.commentSort = this.commentSort;                 
        },  
        ckMenu()
        {
          //질의문의 메뉴만 정렬 반대 이걸 왜 해달라는거야 진짜!!
            if(this.$store.state.menu.activeSubMenu ==="gameqna")
            {
               this.commentSort ="asc";
            }else{
                this.commentSort ="desc";
            }   
        },       
        show_ccommentform(e)
        {      
            //console.log(e);
            let toggle = e.target.nextSibling.style.display;      
            //전체 대댓글 폼 하이드
            let elems =  document.querySelectorAll('.ccomment_form');
            let index = 0, length = elems.length;
            for ( ; index < length; index++) {
                elems[index].style.display = "none";                     
            }
            
            if(toggle ==="none" )
            {
                e.target.nextSibling.style.display ="block"
            }else{
                e.target.nextSibling.style.display="none" 
               
            }                       
           
        },
        showRecomment(e,comment_id)
        {
            //alert(comment_id);
            //console.log(e);           
           
            let display = document.querySelector('.ccomment_form_'+comment_id).style.display;    
            //전체 대댓글 폼 하이드
            let elems =  document.querySelectorAll('.ccomment_form');
            let index = 0, length = elems.length;
            for ( ; index < length; index++) {
                elems[index].style.display = "none";                     
            }
            if(display==="none")
            {
                document.querySelector('.ccomment_form_'+comment_id).style.display="block"
            }else{
                document.querySelector('.ccomment_form_'+comment_id).style.display="none"
            }
            // if(toggle ==="none" )
            // {
            //     e.target.nextSibling.style.display ="block"
            // }else{
            //     e.target.nextSibling.style.display="none" 
               
            // }      
        },
        async deleteComment(id){
            if(confirm('삭제하시겠습니까?'))
            {
                try {
                    let response = await this.$store.dispatch("posts/deleteComment", id);        
                    if(this.currentUser.role !=='admin' && response.state==='info')
                    {
                        this.$store.commit('updateUserPoint',response.user);       
                    }
                    this.$emit("delete-comment", id);   
                    this.$flashMessage.show({type: response.state,title: response.message,message: response.message,});  

                }catch(error)
                {
                    console.log(error);
                }
            }else{
                return;
            }            
        },
       
    }

}
</script>

<style lang="scss" scoped>
 .comments_wrap{
    margin-top: 20px;
    font-size:12px;
    margin-bottom:20px;
    .top{
        line-height:50px;
        display:flex;
        span{color: #ed2026;}
        .select_sort{margin-left:10px;}
    }
    .comments{
        border-top: 1px solid #dee3eb;
        .item{
             
             padding:30px 0 10px 0;
            .register_info{
                display:flex;
                align-items: center;
                .recomment{
                    cursor: pointer;
                }
                .regdate:before,.recomment:before{
                    content: "";
                    display: block;
                    float: left;
                    margin: 8px 10px 0 10px;
                    width: 1px;
                    height: 1px;
                    background: #000;
                }
                .regdate{
                    flex:1 auto;
                }
                .btn_delete{
                    color:red;
                }
               
            }
           
            
            .comment_cont{
                padding:10px 0 0 20px;
                pre{
                    white-space: break-spaces;
                }
            }
             .ccomment_form{
                margin-top:10px;
                display:none;
            }
        }
        .ccomment{            
            padding: 10px 0 10px 30px;
            .user{display:flex;}
            .comment_cont{
                padding-left:30px;
                .touser{
                    font-weight: bold;
                }
            }
        }
        .ccomment_write{
            font-weight:bold;
            margin-top:30px;
            padding-bottom:10px;
            border-bottom: 1px solid #dee3eb;
            span{
                cursor:pointer;         
            }                        
            .ccomment_form{
                margin-top:10px;
                display:none;
            }
        }
    }
}
</style>
